// Dates and times are parking-local wall times (Europe/Rome), not UTC.
// These exceptions apply only to the specified dates, never annually.
export const temporaryClosures = [
    { date: '2026-09-15', startsAt: '00:00', reopensAt: '16:00' },
    { date: '2026-10-01', startsAt: '07:00', reopensAt: '16:00' },
];
export const temporaryClosureMessageKey = 'stepper.temporaryClosure';

export const returnTimeFields = ['disembark_time', 'train_arrival_time', 'pickup_time'];

export function isClosedDate(date) {
    return temporaryClosures.some((closure) => closure.date === date);
}

export function isBlockedTime(date, time) {
    return (
        Boolean(time) &&
        temporaryClosures.some(
            (closure) => closure.date === date && time >= closure.startsAt && time < closure.reopensAt
        )
    );
}

export function formatPickerDate(date) {
    const pad = (value) => String(value).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

export function formatPickerTime(date) {
    const pad = (value) => String(value).padStart(2, '0');
    return `${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function isPickerTimeAvailable(time, date = formatPickerDate(time)) {
    return !isBlockedTime(date, formatPickerTime(time));
}

export function hasBlockedBookingTime(data, includeTransfer = true) {
    if (isBlockedTime(data.checkin_date, data.checkin_time) || isBlockedTime(data.checkout_date, data.checkout_time)) {
        return true;
    }

    if (!includeTransfer || !data.has_transfer || !['return', 'outbound_return'].includes(data.transfer_type)) {
        return false;
    }

    const field = {
        harbour: 'disembark_time',
        station: 'train_arrival_time',
        city: 'pickup_time',
        other: 'pickup_time',
    }[data.pickup_place];

    return isBlockedTime(data.checkout_date, data[field]);
}

// Keep the selected date visible, but require a new time rather than silently
// moving a customer's arrival, departure or transfer to 16:00.
export function clearBlockedTimes(data) {
    const next = { ...data };
    for (const field of ['checkin', 'checkout']) {
        if (isBlockedTime(next[`${field}_date`], next[`${field}_time`])) {
            next[`${field}_time`] = '';
        }
    }
    for (const field of returnTimeFields) {
        if (isBlockedTime(next.checkout_date, next[field])) {
            next[field] = '';
        }
    }
    return next;
}
